<template>
  <div class="training-intents">
    <main-layout>
      <template v-if="currentView == 'list'">
        <div style="position: relative; min-height: 100vh">
          <v-premium-plan-popup
            :showAll="false"
            marginTop="65"
            v-if="$store.getters.getPackage != 'premium' || isCoachlab"
          ></v-premium-plan-popup>
          <div class="container-fluid" style="padding: 25px 15px">
            <div class="row">
              <div class="col s12 m8">
                <h5>{{ $t('Default Conversation') }}</h5>
              </div>
              <div class="col s12 m4 form-control">
                <input type="text" :placeholder="$t('Search')" v-model="search" />
              </div>
            </div>
            <div class="row">
              <div class="col s12 m8" style="overflow-x: auto; white-space: nowrap">
                <!--:class="{'btn-primary': currentFilter == 'today' , 'btn-outline-gray' : currentFilter != 'today' }" -->
                <v-btn
                  class="primaryButton"
                  href="javascript:void(0)"
                  :depressed="currentFilter == 'today'"
                  :outline="currentFilter != 'today'"
                  :color="currentFilter == 'today' ? 'primary' : `grey`"
                  style="margin-bottom: 5px"
                  @click="changeDate('today')"
                  >{{ $t('today') }}</v-btn
                >
                <v-btn
                  class="primaryButton"
                  href="javascript:void(0)"
                  :depressed="currentFilter == 'this_month'"
                  :outline="currentFilter != 'this_month'"
                  :color="currentFilter == 'this_month' ? 'primary' : `grey`"
                  style="margin-bottom: 5px"
                  @click="changeDate('this_month')"
                  >{{ $t('this month') }}</v-btn
                >
                <v-btn
                  class="primaryButton"
                  href="javascript:void(0)"
                  :depressed="currentFilter == 'this_year'"
                  :outline="currentFilter != 'this_year'"
                  :color="currentFilter == 'this_year' ? 'primary' : `grey`"
                  style="margin-bottom: 5px"
                  @click="changeDate('this_year')"
                  >{{ $t('this year') }}</v-btn
                >
                <v-btn
                  class="primaryButton"
                  href="javascript:void(0)"
                  :depressed="currentFilter == 'last_month'"
                  :outline="currentFilter != 'last_month'"
                  :color="currentFilter == 'last_month' ? 'primary' : `grey`"
                  style="margin-bottom: 5px"
                  @click="changeDate('last_month')"
                  >{{ $t('last 30 days') }}</v-btn
                >
                <v-btn
                  class="primaryButton"
                  href="javascript:void(0)"
                  :depressed="currentFilter == 'last_365_day'"
                  :outline="currentFilter != 'last_365_day'"
                  :color="currentFilter == 'last_365_day' ? 'primary' : `grey`"
                  style="margin-bottom: 5px"
                  @click="changeDate('last_365_day')"
                  >{{ $t('last 365 days') }}</v-btn
                >
                <v-btn
                  class="primaryButton"
                  href="javascript:void(0)"
                  :depressed="currentFilter == 'custom_date'"
                  :outline="currentFilter != 'custom_date'"
                  :color="currentFilter == 'custom_date' ? 'primary' : `grey`"
                  style="margin-bottom: 5px"
                  @click="changeDate('custom_date')"
                  >{{ $t('Custom Date') }}</v-btn
                >
              </div>
              <div class="col s12 m4 text-xs-left text-sm-right">
                <a
                  href="javascript:void(0)"
                  class="btn btn-floating btn-small btn-outline-red"
                  :class="{ active: view == 'tag' }"
                  @click="view = 'tag'"
                >
                  <span class="fas fa-th"></span>
                </a>
                <a
                  href="javascript:void(0)"
                  class="btn btn-floating btn-small btn-outline-red"
                  :class="{ active: view == 'list' }"
                  @click="view = 'list'"
                >
                  <span class="fas fa-bars"></span>
                </a>

                <v-btn
                  depressed
                  outline
                  color="primary"
                  :loading="loading"
                  :disabled="filterDefaultIntents.length == 0"
                  @click="onExportTraining"
                >
                  <i class="fas fa-file-export"></i>
                  &nbsp;{{ $t('export') }}&nbsp;
                  <v-premium-lock :inline="true"></v-premium-lock>
                </v-btn>
              </div>

              <div class="row" v-if="currentFilter == 'custom_date'" style="margin-bottom: 0">
                <div class="col s12 m6">
                  <span class="dashboard_datepicker">
                    {{ $t('from') }}:
                    <datepicker
                      v-model="selectedDate.start"
                      style="margin-bottom: 10px"
                      @selected="onSelectedStartDate"
                    ></datepicker>
                  </span>
                </div>
                <div class="col s12 m6">
                  <span class="dashboard_datepicker" style="margin-bottom: 10px">
                    {{ $t('to') }}:
                    <datepicker
                      v-model="selectedDate.end"
                      style
                      @selected="onSelectedEndDate"
                    ></datepicker>
                  </span>
                </div>
                <div class="col s12">
                  <div class="text-xs-right">
                    <v-btn color="primary" @click="loadTraining" small :loading="loading">
                      {{ $t('Search') }}
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <v-container fluid v-if="selectedBot.theme == 'universalutilities'">
            <div class="primary--text" v-if="selectedBot.uu_areaname">
              {{ selectedBot.uu_areaname }}
            </div>
            <template v-else>
              <multiselect
                v-model="uuAreaName"
                :options="$store.state.uuAreaName"
                selectLabel
                selectedLabel
                :searchable="false"
                deselect-label
                data-vv-as="ประปา"
                data-vv-name="uuAreaName"
                v-validate="'required'"
                @select="onSelectUuAreaName"
                @remove="onSelectUuAreaName('')"
              ></multiselect>
            </template>
          </v-container>
          <div v-if="firstloading">
            <scale-loader :color="$vuetify.theme.primary" height="35px" width="7px"></scale-loader>
          </div>
          <template v-else>
            <template v-if="filterDefaultIntents.length > 0">
              <div style="padding: 0 15px">
                <div>
                  <div
                    style="
                      background: #eee;
                      padding: 15px 15px 0;
                      margin-bottom: 15px;
                      border-radius: 5px;
                    "
                  >
                    <div class="row" style="margin-bottom: 0">
                      <div class="col s12 m5">
                        <v-checkbox
                          color="primary"
                          v-model="allSelected"
                          :label="$t('Select All')"
                          style="margin-top: 0"
                        ></v-checkbox>
                      </div>
                      <div class="col s12 m7 text-xs-left text-sm-right">
                        <v-btn
                          href="javascript:void(0)"
                          outline
                          color="grey"
                          :loading="loading || loadingIntent"
                          class="primaryButton"
                          @click="
                            $store.getters.getPackage == 'premium' && !isCoachlab
                              ? ignoreAll()
                              : false
                          "
                          :disabled="selectedQuestionData.length == 0"
                          style="margin-bottom: 5px"
                          >{{ $t('Delete') }}</v-btn
                        >
                        <v-btn
                          depressed
                          color="primary"
                          class="primaryButton"
                          href="javascript:void(0)"
                          :loading="loading || loadingIntent"
                          @click="createNewAll"
                          :disabled="selectedQuestionData.length == 0"
                          style="margin-bottom: 5px"
                          >{{ $t('Create new') }}</v-btn
                        >
                        <v-btn
                          depressed
                          color="primary"
                          class="primaryButton"
                          href="javascript:void(0)"
                          :loading="loading || loadingIntent"
                          :disabled="selectedQuestionData.length == 0"
                          style="margin-bottom: 5px"
                          @click="
                            currentDefaultIntents = selectedQuestionData
                            showModal = true
                          "
                          >{{ $t('Add existing') }}</v-btn
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <div class="container-fluid" style="padding: 0 15px">
              <div
                id="training_container"
                style="
                  max-height: 600px;
                  overflow-y: auto;
                  border: 1px solid #eee;
                  padding: 10px;
                  border-radius: 5px;
                "
              >
                <div class="row" style="margin-bottom: 0">
                  <div class="col s12">
                    <template v-if="filterDefaultIntents.length > 0">
                      <div class="container-fluid">
                        <template v-if="view == 'tag'">
                          <div class="text-xs-center" v-if="!loading">
                            <v-pagination
                              v-if="!search"
                              v-model="pageNumber"
                              :length="pageCount"
                              @input="onClickPageinate"
                              class="mb-2"
                            ></v-pagination>
                          </div>
                          <ul class="tags">
                            <li
                              class="tag"
                              :class="{ active: intent.selected }"
                              style="
                                margin-right: 5px;
                                margin-bottom: 5px;
                                cursor: pointer;
                                text-align: left;
                              "
                              v-for="(intent, index) in filterDefaultIntents"
                              :key="'intent_' + intent.id + '_' + index"
                              :title="intent.questiondata"
                              @click="intent.selected = !intent.selected"
                            >
                              <!-- <span
                                :class="{
                                  'fas fa-check-circle': intent.selected,
                                  'far fa-circle': !intent.selected,
                                }"
                              ></span> -->
                              <span
                                v-tooltip.top="
                                  intent.first_name
                                    ? intent.first_name + ' ' + intent.last_name
                                    : 'ไม่ระบุ'
                                "
                              >
                                <v-avatar size="32px">
                                  <v-img
                                    v-if="intent.profile_pic"
                                    :src="intent.profile_pic"
                                  ></v-img>
                                  <v-icon large v-else>account_circle</v-icon>
                                </v-avatar>
                              </span>
                              <div
                                style="
                                  display: inline-block;
                                  vertical-align: middle;
                                  word-break: break-all;
                                "
                              >
                                {{ intent.questiondata }}
                              </div>
                              <template v-if="intent.count > 1">({{ intent.count }})</template>
                            </li>
                          </ul>
                          <div class="text-xs-center" v-if="!loading">
                            <v-pagination
                              v-if="!search"
                              v-model="pageNumber"
                              :length="pageCount"
                              @input="onClickPageinate"
                              class="mb-2"
                            ></v-pagination>
                          </div>
                        </template>

                        <template v-else>
                          <div class="text-xs-center" v-if="!loading">
                            <v-pagination
                              v-if="!search"
                              v-model="pageNumber"
                              :length="pageCount"
                              @input="onClickPageinate"
                              class="mb-2"
                            ></v-pagination>
                          </div>
                          <training-item
                            :loadingId="loadingId"
                            class="z-border-red"
                            style="padding: 10px 10px 0"
                            v-for="(intent, index) in filterDefaultIntents"
                            :key="'intent_' + intent.id + '_' + index"
                            v-model="filterDefaultIntents[index]"
                            @onAddExistingConversation="
                              currentDefaultIntents = []
                              currentDefaultIntents.push(intent.questiondata)
                              showModal = true
                            "
                            @onSaveTrainingConversation="saveTrainingIntent"
                            :excludedIntentName="excludedIntentName"
                            @onIgnore="onIgnore(intent.questiondata)"
                          ></training-item>
                          <div class="text-xs-center">
                            <v-pagination
                              v-if="!loading && !search"
                              v-model="pageNumber"
                              :length="pageCount"
                              @input="onClickPageinate"
                              class="mb-2"
                            ></v-pagination>
                          </div>
                        </template>
                      </div>
                    </template>
                    <template v-else>
                      <div class="text-xs-center" style="margin: 35px 0">
                        <img
                          src="/static/img/assets/setting/conversation.png"
                          alt
                          style="width: 230px"
                        />
                        <h3>{{ $t('No conversation') }}</h3>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>

        <div style="height: 60px"></div>

        <modal-dialog v-if="showModal" @close="showModal = false" :isFixed="true">
          <div slot="header">
            <h5>{{ $t('Training') }}</h5>
            <div class="row" style="margin-bottom: 0">
              <div class="col s12">
                <div class="form-control">
                  <input type="text" :placeholder="$t('Search')" v-model="searchIntent" />
                </div>
              </div>
            </div>
            <div class="hr" style="margin: 0 -10px 0px"></div>
          </div>

          <div slot="body">
            <div class="row" style="margin-top: 10px; margin-bottom: 10px">
              <div class="col s12">
                <ul class="training-data" style="margin: 0; padding: 0">
                  <li
                    class="item z-border-red"
                    v-for="(intent, index) in filterIntents"
                    :key="'intent_' + index"
                    @click="addTrainingToConversation(intent)"
                  >
                    {{ intent.intentname }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div
            slot="footer"
            class="row text-xs-center"
            style="border-top: 1px solid #eee; padding-top: 10px; margin-bottom: 0"
          >
            <a href="javascript:void(0);" class="btn btn-default" @click="showModal = false">{{
              $t('cancel')
            }}</a>
          </div>
        </modal-dialog>
      </template>
      <template v-else-if="currentView == 'create_new'">
        <div class="container">
          <div class="row">
            <div class="col s12">
              <manage-intent
                :type="'add'"
                v-model="newIntent"
                @close="onClose"
                @saveIntent="onSaveIntent"
                :excludedIntentName="excludedIntentName"
              ></manage-intent>
            </div>
          </div>
        </div>
      </template>
    </main-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ModalDialog from '@/components/elements/ModalDialog'
import TrainingItem from './TrainingItem'
import api from '@/api'
// import { clearInterval } from "timers";

import datepicker from 'vuejs-datepicker'
import moment from 'moment'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import ManageIntent from './intent-manage'
import Multiselect from 'vue-multiselect'

import XLSX from 'xlsx'
export default {
  data: function () {
    return {
      tmp_intent: [],
      alltrainingdata: [],
      pageNumber: 1,
      size: 50,
      loadingId: '',
      currentView: 'list',
      training_intents: [],
      loading: false,
      loadingIntent: true,
      firstloading: true,
      intents: [],
      search: '',
      searchIntent: '',
      showModal: false,
      currentDefaultIntents: [],
      allSelected: false,
      selectedDate: {
        start: moment().startOf('month').toDate(),
        end: moment().endOf('month').toDate(),
      },
      currentFilter: 'this_month',
      ignoreInterval: undefined,
      ignoreCount: 0,
      view: 'tag',
      newIntent: {
        intentname: '',
        q_type: 'text',
        a_type: 'json',
        q_val: '',
        a_val: '[[]]',
        context_in: '',
        context_out: '',
        postidlist: '',
        userstatus: '',
        usertags: '',
        isShow: false,
        userstatus: null,
        usertags: null,
        linenoti_status: false,
        linenoti_text: null,
        starttime: null,
        endtime: null,
        intentstatus: true,
      },
      training_process_count: 0,
      loadingTraining: null,
      uuAreaName: '',

      trainingCount: 0,
      offset: 0,
      total: 0,
    }
  },
  components: {
    ModalDialog,
    TrainingItem,
    datepicker,
    ScaleLoader,
    ManageIntent,
  },
  mounted: async function () {
    var vm = this
    if (vm.$store.getters.getPackage != 'premium' || vm.isCoachlab) {
      return false
    }
    if (vm.$route.query.datefrom) {
      vm.selectedDate.start = vm.$route.query.datefrom
    }
    if (vm.$route.query.dateto) {
      vm.selectedDate.end = vm.$route.query.dateto
    }
    if (vm.$route.query.datefrom || vm.$route.query.dateto) {
      vm.currentFilter = 'custom_date'
    }

    vm.firstloading = true
    try {
      var response = await vm.getTrainingConversation({ limit: vm.size, offset: vm.offset })
      vm.training_intents = response.training
      vm.total = response.total
    } catch (error) {}
    vm.firstloading = false
    this.loadingIntent = true
    try {
      await vm.getIntent()
    } catch (error) {}
    this.loadingIntent = false
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab',
    }),
    pageCount: function () {
      let l = this.total
      let s = this.size
      return Math.ceil(l / s)
    },
    excludedIntentName: function () {
      var result = []
      var vm = this
      result = vm.intents.map((intent) => {
        return intent && intent.intentname ? intent.intentname : null
      })

      return result.join(',')
    },
    filterDefaultIntents: function () {
      var vm = this
      var sorted = vm.training_intents.sort(function (a, b) {
        var nameA = a.questiondata.toUpperCase()
        var nameB = b.questiondata.toUpperCase()
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })

      var training = sorted.filter((intent) => {
        var isFound = false
        if (intent.questiondata != null && intent.questiondata != '') {
          isFound =
            intent.questiondata.toLowerCase().includes(vm.search.toLowerCase()) &&
            intent.training != true
        }
        return isFound
      })

      vm.trainingCount = training.length
      return training
      // const start = (this.pageNumber - 1) * this.size
      // const end = start + this.size
      // return training.slice(start, end)
    },
    filterIntents: function () {
      var vm = this
      vm.intents.sort(function (a, b) {
        var nameA = a.intentname.toUpperCase() // ignore upper and lowercase
        var nameB = b.intentname.toUpperCase() // ignore upper and lowercase
        if (a.intentname[0] == '{' && a.intentname[a.intentname.length - 1] == '}') {
          return 1
        }
        if (b.intentname[0] == '{' && b.intentname[b.intentname.length - 1] == '}') {
          return -1
        }
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })

      return vm.intents.filter((intent) => {
        var isFound
        if (intent && intent.intentname) {
          isFound = intent.intentname.toLowerCase().includes(vm.searchIntent.toLowerCase())
          //  ||
          // intent.q_val.toLowerCase().includes(vm.searchIntent.toLowerCase()) ||
          // intent.a_val.toLowerCase().includes(vm.searchIntent.toLowerCase())
          return isFound
        } else isFound
      })
    },
    selectedQuestionData: function () {
      var questions = []
      var vm = this
      if (vm.filterDefaultIntents) {
        vm.filterDefaultIntents.map(function (el) {
          if (el.selected) {
            questions.push(el.questiondata)
          }
        })
      }
      return questions
    },
  },
  methods: {
    onSelectUuAreaName: function (type) {
      var vm = this
      vm.loading = true
      vm.uuAreaName = type
      this.getTrainingConversation().then(
        function () {
          vm.loading = false
        },
        function (err) {
          vm.loading = false
        }
      )
    },

    async onClickPageinate(pageNum) {
      this.pageNumber = pageNum
      this.firstloading = true
      if (pageNum == 1) {
        this.offset = 0
      } else {
        this.offset = (pageNum - 1) * this.size
      }
      try {
        var response = await this.getTrainingConversation({ limit: this.size, offset: this.offset })
        this.training_intents = response.training
        this.total = response.total
      } catch (error) {
        console.log(error)
      }
      this.firstloading = false
      this.$nextTick(() => {
        $('html, body').animate({
          scrollTop: 0,
        })
        $('#training_container').animate({
          scrollTop: 0,
        })
      })
    },
    onSaveIntent: async function (payload) {
      var vm = this
      vm.loading = true
      vm.currentView = 'list'
      let trainingPromise = []
      if (vm.selectedQuestionData) {
        vm.loading = true
        vm.training_process_count = vm.selectedQuestionData.length
        var questionDataIntents = vm.training_intents.filter((intent) => {
          return intent.selected
        })
        var datapayload = {
          intentname: payload.intentname,
          chatloglist: [].concat.apply(
            [],
            questionDataIntents.map((el) => el.idlist)
          ), //merge all array
        }
        await vm.saveTrainingIntent(datapayload)

        // vm.currentDefaultIntents = []
        vm.loading = false
      }
    },
    onClose: function () {
      this.currentView = 'list'
    },
    onSelectedStartDate: async function (value) {
      var vm = this
      vm.currentFilter = 'custom_date'
      if (moment(this.selectedDate.end).isBefore(value)) {
        this.selectedDate.end = value
      }
      this.selectedDate.start = value
    },
    createNewAll: function () {
      var vm = this

      vm.newIntent = {
        intentname: '',
        q_type: 'text',
        a_type: 'json',
        q_val: vm.selectedQuestionData.join(','),
        a_val: '[[]]',
        context_in: '',
        context_out: '',
        postidlist: '',
        userstatus: '',
        usertags: '',
        isShow: false,
        userstatus: null,
        usertags: null,
        linenoti_status: false,
        linenoti_text: null,
        starttime: null,
        endtime: null,
        intentstatus: true,
      }
      vm.currentView = 'create_new'
    },
    onSelectedEndDate: async function (value) {
      var vm = this
      vm.currentFilter = 'custom_date'
      if (moment(value).isBefore(this.selectedDate.start)) {
        this.selectedDate.start = value
      }
      this.selectedDate.end = value
    },
    async loadTraining() {
      this.loading = true
      try {
        this.offset = 0
        var response = await this.getTrainingConversation({ limit: this.size, offset: this.offset })
        this.training_intents = response.training
        this.total = response.total
        this.pageNumber = 1
      } catch (error) {}
      this.loading = false
    },
    onSelectedDate: async function (value) {
      var vm = this
      vm.loading = true
      try {
        vm.offset = 0
        var response = await vm.getTrainingConversation({ limit: vm.size, offset: vm.offset })
        vm.training_intents = response.training
        vm.total = response.total
        vm.pageNumber = 1
      } catch (error) {}
      vm.loading = false
    },
    changeDate: function (value) {
      var vm = this
      vm.currentFilter = value
      switch (value) {
        case 'today':
          vm.selectedDate.start = moment().toDate()
          vm.selectedDate.end = moment().toDate()
          vm.onSelectedDate()
          break

        case 'last_month':
          vm.selectedDate.start = moment().subtract(1, 'months').toDate()
          vm.selectedDate.end = moment().toDate()
          vm.onSelectedDate()
          break

        case 'this_month':
          vm.selectedDate.start = moment().startOf('month').toDate()
          vm.selectedDate.end = moment().endOf('month').toDate()
          vm.onSelectedDate()
          break

        case 'this_year':
          vm.selectedDate.start = moment().startOf('year').toDate()
          vm.selectedDate.end = moment().endOf('year').toDate()
          vm.onSelectedDate()
          break

        case 'last_365_day':
          vm.selectedDate.start = moment().subtract(365, 'days').toDate()
          vm.selectedDate.end = moment().toDate()
          vm.onSelectedDate()
          break
        case 'custom_date':
          break
      }
    },
    getTrainingConversation: function (pageinate) {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          pageid: vm.selectedBot.pageid,
          intentname: '{default}',
          datefrom: moment(vm.selectedDate.start).format('YYYY-MM-DD'),
          dateto: moment(vm.selectedDate.end).format('YYYY-MM-DD'),
          limit: pageinate.limit,
          offset: pageinate.offset,
          training: 'false',
        }
        if (vm.selectedBot.theme == 'universalutilities') {
          if (vm.selectedBot.uu_areaname) {
            data.uu_areaname = vm.selectedBot.uu_areaname
          } else if (vm.uuAreaName != '') {
            data.uu_areaname = vm.uuAreaName
          }
        }
        api.getTraningConversation(data, function (error, response) {
          if (error) {
            reject(error)
          }
          // console.timeEnd('load training')
          var training_intents = []
          $.each(response.data, function (index, intent) {
            var tmp_intent = intent
            tmp_intent.selected = false

            var isFound = false
            $.each(training_intents, function (index, value) {
              if (value.id != tmp_intent.id && tmp_intent.questiondata == value.questiondata) {
                training_intents[index].count += 1
                training_intents[index].idlist.push(tmp_intent.id)
              }

              if (value.id != tmp_intent.id && tmp_intent.questiondata == value.questiondata) {
                isFound = true

                return false
              }
            })

            if (!isFound) {
              tmp_intent.count = 1
              Object.assign(tmp_intent, { idlist: [tmp_intent.id] })

              training_intents.push(tmp_intent)
            }
          })

          resolve({
            training: training_intents,
            total: response.total,
          })
        })
      })
    },
    getIntent: function () {
      let vm = this
      let auth = null
      let data = {
        pageid: vm.selectedBot.pageid,
      }
      vm.intents = []
      return new Promise((resolve, reject) => {
        // console.time('load intent')
        api.getIntent(data, function (error, response) {
          if (error) {
            reject(error)
          }
          // console.timeEnd('load intent')
          if (response.data) {
            var isFoundDefault = false
            var intents = response.data.map((val) => {
              var intent = val
              intent.isShow = false
              intent.ableToDelete = true
              if (intent.intentname == '{default}') {
                intent.ableToDelete = false
                isFoundDefault = true
                vm.default_intent = intent
              } else {
                return intent
              }
            })
            vm.intents = intents
          }
          resolve()
        })
      })
    },
    addTrainingToConversation: async function (intent) {
      let vm = this
      if (
        !vm.currentDefaultIntents ||
        (vm.currentDefaultIntents && vm.currentDefaultIntents.length == 0)
      ) {
        return false
      }

      let data = {
        q_val: vm.currentDefaultIntents.join(','),
        pageid: vm.selectedBot.pageid,
      }

      // let data = {
      //   pageid: vm.selectedBot.pageid,
      //   intentname: intent.intentname,
      //   q_type: intent.q_type,
      //   q_val: intent.q_val + ',' + vm.currentDefaultIntents.join(','),
      //   a_type: intent.a_type,
      //   a_val: intent.a_val.replace(/ /gim, ' '),
      //   context_in: intent.context_in,
      //   context_out: intent.context_out,
      //   quick_reply: intent.quick_reply
      // }

      // if (data.a_type == 'message' || data.a_type == 'generic') {
      //   data.a_val = '{welcome_message}'
      // } else if (data.a_type == 'template') {
      //   data.a_val = JSON.stringify(vm.generics)
      // } else if (data.a_type == 'viewsummary') {
      //   data.a_val = '{viewsummary}'
      // } else if (data.a_type == 'none') {
      //   data.a_val = ''
      // }

      // if (vm.isReplyComment) {
      //   data.a_val = vm.replyComment
      // }

      var result = await vm.$swal.fire({
        title: vm.$t('Do you want to add {question} to {intent}?', {
          question: (
            vm.currentDefaultIntents[0] + (vm.currentDefaultIntents.length > 1 ? '...' : '')
          ).replace(/\<|\>/g, ''),
          intent: intent.intentname.replace(/\<|\>/g, ''),
        }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true,
      })
      if (result.value) {
        vm.loading = true
        vm.showModal = false
        data['id'] = intent.id
        var request = {
          data: data,
          params: {
            id: data['id'],
          },
        }
        let trainingPromise = []
        try {
          let response = await this.putQvalIntents(request)
          if (vm.currentDefaultIntents) {
            // vm.loadingId = vm.currentDefaultIntents[0]
            // vm.training_process_count = vm.currentDefaultIntents.length
            var questionDataIntents = vm.training_intents.filter((intent) => {
              return intent.selected
            })
            var datapayload = {
              intentname: intent.intentname,
              chatloglist: [].concat.apply(
                [],
                questionDataIntents.map((el) => el.idlist)
              ), //merge all array
            }

            await vm.saveTrainingIntent(datapayload)

            vm.currentDefaultIntents = []
            vm.loading = false
            // vm.getIntent(function() {
            //   vm.getTrainingConversation().then(
            //     function() {
            //       vm.loading = false
            //     },
            //     function(err) {
            //       vm.loading = false
            //     }
            //   )
            // })
          }

          // vm.loadingTraining = setInterval(function() {
          //   if (vm.training_process_count === 0) {
          //     if (vm.loadingTraining) {
          //       clearInterval(vm.loadingTraining)
          //       vm.currentDefaultIntents = []
          //       vm.getIntent(function() {
          //         vm.getTrainingConversation().then(
          //           function() {
          //             vm.loading = false
          //           },
          //           function(err) {
          //             vm.loading = false
          //           }
          //         )
          //       })
          //     }
          //   }
          // }, 1000)
        } catch (error) {
          console.error(error)
          vm.loading = false
        }
      }
    },
    putQvalIntents(request) {
      return new Promise((resolve, reject) => {
        api.putQvalIntents(request, function (error, response) {
          if (error) {
            reject(error)
          }

          resolve()
        })
      })
    },
    putupdateTrainingConversation: function (data, callback) {
      var vm = this
      api.putupdateTrainingConversation(data, function (error, response) {
        if (error) {
          console.error(error)
          callback()
          return
        }
        if (vm.training_intents.length <= 0) {
          callback(null)
          return false
        }
        $.each(vm.training_intents, function (index, intent) {
          if (intent.questiondata == data.questiondata) {
            callback(index)
            return false
          }
        })
      })
    },
    saveTrainingIntent: function (payload) {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          pageid: vm.selectedBot.pageid,
          questiondata: payload.questiondata,
          chatloglist: payload.chatloglist,
          newintent: payload.intentname,
        }
        api.putupdateTrainingConversation(data, function (err, response) {
          if (response && response.responsecode == 200) {
            var traininglist = []
            response.data.map((el) => {
              traininglist.push(el.questiondata)
            })
            vm.training_intents = vm.training_intents.filter((el) => {
              return !traininglist.includes(el.questiondata)
            })

            resolve(response)
          }
        })
      })
    },
    ignoreAll: async function () {
      var vm = this
      var result = await vm.$swal.fire({
        title: vm.$t('Do you want to ignore selected?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true,
      })

      if (result.value) {
        vm.loading = true

        var intentList = []

        var ignoreIntents = vm.training_intents.filter((intent) => {
          return intent.selected
        })
        // ignoreIntents.forEach((intent) => {
        //   intentList.push(intent.id)
        // })

        vm.ignoreTrainingIntent(
          [].concat.apply(
            [],
            ignoreIntents.map((el) => el.idlist)
          )
        ) //merge all array)

        // await Promise.all(promiseIgnoreTrainingIntent)
        var questiondata = ignoreIntents.map((intent) => {
          return intent.questiondata
        })

        var filterTraining = vm.training_intents.filter((intent) => {
          return !questiondata.includes(intent.questiondata)
        })

        vm.training_intents = filterTraining

        vm.loading = false

        // vm.ignoreInterval = setInterval(() => {
        //   if (vm.ignoreCount == 0) {
        //     clearInterval(vm.ignoreInterval)

        //   }
        // }, 1000)
      }
    },
    onIgnore: async function (id) {
      var vm = this
      var result = await vm.$swal.fire({
        title: vm.$t('Do you want to ignore selected?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true,
      })
      if (result.value) {
        vm.loading = true
        vm.loadingId = id
        try {
          await vm.ignoreTrainingIntent(id)
          var filterTraining = vm.training_intents.filter((intent) => {
            return intent.questiondata != id
          })
          vm.training_intents = filterTraining

          // await vm.getIntent()
          // var response = await vm.getTrainingConversation({ limit: vm.size, offset: vm.offset })
          // vm.training_intents = response.training
          // vm.total = response.total
        } catch (error) {}
        vm.loading = false
      }
    },
    ignoreTrainingIntent: function (chatloglist) {
      var vm = this
      return new Promise((resolve, reject) => {
        // vm.$store.dispatch("loading");
        var data = {
          pageid: vm.selectedBot.pageid,
          chatloglist: chatloglist,
          newintent: '',
        }
        vm.putupdateTrainingConversation(data, function (index) {
          resolve()
        })
      })
    },
    selectAll: function () {
      var vm = this
      vm.intentId = []
      $.each(vm.filterDefaultIntents, function (index, intent) {
        $.each(vm.training_intents, function (dindex, dintent) {
          if (intent.id == dintent.id) {
            vm.training_intents[dindex].selected = vm.allSelected
            return false
          }
        })
      })
    },
    select: function () {
      this.allSelected = false
    },
    onExportTraining: async function () {
      let vm = this
      let csvContent = ''
      if (vm.loading) {
        return false
      }
      vm.loading = true
      var response = await vm.getTrainingConversation({ limit: vm.total, offset: 0 })
      var training_intents = response.training

      // csvContent += 'Message'

      // csvContent += '\r\n'
      var json = []
      $.each(training_intents, function (index, val) {
        let row = ''

        // row +=
        //   '"' +
        //   (val.questiondata ? val.questiondata : '').replace(/\r?\n|\r/g, ' / ') +
        //   (val.count > 0 ? '(' + val.count + ')' : '') +
        //   '",'

        // csvContent += row + '\r\n'
        json.push({
          message: (val.questiondata ? val.questiondata : '').replace(/\r?\n|\r/g, ' / '),
          count: val.count > 0 ? val.count : 0,
        })
      })

      // vm.exportCsv(csvContent, 'training')
      var dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'training.xlsx')
      vm.loading = false
    },
  },
  watch: {
    allSelected: function (newVal, oldVal) {
      var vm = this
      vm.selectAll()
    },
  },
}
</script>

<style scoped>
.primaryButton {
  margin-left: 0;
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/Training.vue